import { SentryConfig as SentryConfigInterface } from '@lopo-tech/lopo-config/interfaces'

export const SentryConfig: SentryConfigInterface = {
  dsn: 'https://0ec4518a4f34425faf2e295b42463600@kammerjaeger.services.mvp-lab.de/9',
  project: 'web',
  org: 'mein-schaumburg',
  url: 'https://kammerjaeger.services.mvp-lab.de'
}
